import { useCallback, useEffect, useRef } from 'react';

export type AsyncMutationCurrentness = () => boolean;

/** Capture the mounted component/hook instance that started an async action. */
export function useAsyncMutationOwner(): () => AsyncMutationCurrentness {
  const mountedRef = useRef(false);
  const lifecycleRef = useRef(0);

  useEffect(() => {
    mountedRef.current = true;
    lifecycleRef.current += 1;
    return () => {
      mountedRef.current = false;
      lifecycleRef.current += 1;
    };
  }, []);

  return useCallback(() => {
    const capturedLifecycle = lifecycleRef.current;
    return () => mountedRef.current && lifecycleRef.current === capturedLifecycle;
  }, []);
}
